export const MESSAGE_LISTENERS = Symbol('Message Listeners');
export const RESPONSES$ = Symbol('Responses');
export const SEND = Symbol('Send');
export const GET_NEW_ID = Symbol('Get New Id');
export const LISTEN = Symbol('Listen');
export const TERMINATE_MESSAGE$ = Symbol('Terminate Message');
export const RESPONSE = Symbol('Response');
